<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>

        <div class="col-24 col-md-16 px-md-3 py-3 px-3 mb-md-5">
          <div v-show="program.name" class="col d-column">
            <div class="card mb-3">
              <div class="card-body py-3">
                <div class="row">
                  <div class="col">
                    <div
                      class="h-profile h-profile-lg d-flex flex-row no align-items-center"
                    >
                      <div
                        class="align-self-center d-flex align-items-center align-self-center pr-2"
                      >
                        <object
                          width="62"
                          height="62"
                          class="rounded-circle img-lg"
                          :data="program.avatar"
                          type="image/png"
                        >
                          <img
                            width="62"
                            height="62"
                            class="rounded-circle img-lg"
                            src="../../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="d-flex flex-row align-items-center">
                          <h1
                            class="title pt-1 mb-0 mr-2"
                            v-text="program.name"
                          ></h1>
                          <VueCustomTooltip :label="$ml.get('ccpProgPriv')">
                            <span
                              v-show="program?.type == 'private'"
                              class="ico ico-locked mr-1"
                            >
                              <img
                                src="../../../assets/icons/lock.svg"
                                class="ico-13"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip :label="$ml.get('ccpProgPubli')">
                            <span
                              v-show="program?.type == 'public'"
                              class="ico ico-locked mr-1"
                            >
                              <img
                                src="../../../assets/icons/unlock.svg"
                                class="ico-13"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip :label="$ml.get('targetProgram')">
                            <span
                              v-if="program?.target_settings?.active"
                              class="ico ico-vpn mr-1"
                            >
                              <img
                                src="../../../assets/icons/target-icon.svg"
                              />
                            </span>
                          </VueCustomTooltip>

                          <div v-if="program.active_campaign">
                            <span class="ico ico-double mr-1">
                              <VueCustomTooltip
                                :label="$ml.get('doubleScoreAndBounty')"
                                v-if="
                                  program.offers_double_bounty == true &&
                                  program.offers_double_score == true
                                "
                              >
                                <img
                                  src="../../../assets/icons/icon-diamante.svg"
                                />
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('doubleScore')"
                                v-if="
                                  program.offers_double_bounty == false &&
                                  program.offers_double_score == true
                                "
                              >
                                <img
                                  src="../../../assets/icons/icon-star.svg"
                                />
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('doubleReward')"
                                v-if="
                                  program.offers_double_bounty == true &&
                                  program.offers_double_score == false
                                "
                              >
                                <img
                                  src="../../../assets/icons/icon-double-reward.svg"
                                />
                              </VueCustomTooltip>
                            </span>
                          </div>
                          <VueCustomTooltip :label="$ml.get('managedProgram')">
                            <span
                              v-show="program?.managed"
                              class="ico ico-managed mr-1"
                            >
                              <img src="../../../assets/images/bughunt.svg" />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip :label="$ml.get('protectedByNDA')">
                            <span
                              v-if="program?.nda_required"
                              class="ico ico-nda mr-1"
                            >
                              <img
                                src="../../../assets/icons/security-shield.svg"
                              />
                            </span>
                          </VueCustomTooltip>
                          <VueCustomTooltip
                            v-show="program.vpn_required"
                            label="Este programa possui VPN"
                          >
                            <span class="ico ico-vpn mr-1">
                              <img src="../../../assets/images/vpn.png" />
                            </span>
                          </VueCustomTooltip>
                          <ScoreMultiplierIcon
                            class="ml-2"
                            v-if="program.offers_bonus_score"
                            :bonus-score-value="program.bonus_score_value"
                          />
                        </div>
                        <div class="title">
                          <span
                            v-text="
                              $ml
                                .with(
                                  $utils.formatData(
                                    program.createdAt,
                                    $ml.get('ln')
                                  )
                                )
                                .get('publishedDaysAgo')
                            "
                          ></span>
                        </div>
                        <div v-if="file" class="flex-column">
                          <p class="mt-2 p-0">
                            Para acessar os escopos deste programa é necessário
                            se conectar há VPN
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <div class="align-self-end">
                      <input
                        v-if="program.exposed"
                        class="input-none"
                        id="inputSlug"
                        :value="url + '/' + program.slug"
                      />
                      <div class="d-flex">
                        <VueCustomTooltip
                          v-if="program.exposed"
                          :label="textTolltip"
                        >
                          <a
                            @click="copyLink()"
                            @mouseout="textTolltip = 'Copiar link'"
                            class="my-2 pointer"
                          >
                            <!-- <font v-text="$ml.get('share')">Share</font> -->
                            <svg width="17" height="17" class="m-2">
                              <image
                                xlink:href="../../../assets/icons/share-node.svg"
                                width="17"
                                height="17"
                              />
                            </svg>
                          </a>
                        </VueCustomTooltip>
                        <!-- hof -->
                        <div class="d-flex flex-lg-row">
                          <div class="align-self-end">
                            <div class="d-flex">
                              <div
                                @click="openHof()"
                                v-if="hallOfFame"
                                class="d-flex align-items-center pointer mb-1 mr-3"
                              >
                                <svg width="20" height="20" class="m-1">
                                  <image
                                    xlink:href="../../../assets/icons/trophy.svg"
                                    width="20"
                                    height="20"
                                  />
                                </svg>
                                <span class="title-subscribe"
                                  >Hall da Fama</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- hof -->
                        <VueCustomTooltip
                          :label="$ml.get('enableEmailNotification')"
                        >
                          <div
                            @click="toggleSubscribe()"
                            v-if="!activeSubscribe"
                            class="d-flex align-items-center pointer"
                          >
                            <svg width="20" height="20" class="m-1">
                              <image
                                xlink:href="../../../assets/icons/notification_off.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                            <span class="title-subscribe">Subscribe</span>
                          </div>
                          <div
                            @click="toggleSubscribe()"
                            v-else
                            class="d-flex align-items-center pointer"
                          >
                            <svg width="20" height="20" class="m-1">
                              <image
                                xlink:href="../../../assets/icons/notification_on.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                            <span class="title-subscribe" style="color: #730ba9"
                              >Subscribe</span
                            >
                          </div>
                        </VueCustomTooltip>
                      </div>
                    </div>

                    <div class="align-self-end row">
                      <div
                        v-if="file"
                        class="align-self-start d-flex mt-2 mr-4"
                      >
                        <a download="file_vpn.zip" :href="file" class="pointer">
                          <font>Link vpn</font>
                          <svg width="17" height="17" class="m-2 my-2">
                            <image
                              xlink:href="../../../assets/icons/download_vpn.svg"
                              width="17"
                              height="17"
                            />
                          </svg>
                        </a>

                        <div class="d-flex align-items-center">
                          <VueCustomTooltip
                            :label="!online ? 'Offline' : 'Online'"
                          >
                            <span :class="online ? 'dot online' : 'dot'"></span>
                          </VueCustomTooltip>
                        </div>
                      </div>

                      <a
                        class="badge badge-secondary text-white p-1 detailPaused"
                        v-if="
                          program.status === 'paused' ||
                          program.status === 'archived'
                        "
                        v-text="$ml.get('paused')"
                      >
                        Pausado
                      </a>
                      <a
                        v-else
                        @click="submitReport()"
                        class="btn btn-top"
                        v-text="$ml.get('submitReport')"
                        >Submeter Relatório</a
                      >
                    </div>

                    <div class="mt-2">
                      <div
                        class="d-flex justify-content-end align-items-center"
                        style="gap: 10px; border-radius: 8px"
                        :style="{
                          border:
                            program?.offers_double_bounty &&
                            program?.active_campaign && !program?.target_settings?.active
                              ? '1px solid rgb(115 12 169 / 29%)'
                              : '',
                          padding:
                            program?.offers_double_bounty &&
                            program?.active_campaign && !program?.target_settings?.active
                              ? '0px 10px'
                              : '',
                        }"
                      >
                        <div
                          v-if="
                            program.offers_bounty &&
                            !program.target_settings.active
                          "
                          class="d-flex justify-content-end align-items-center"
                        >
                          <svg
                            width="48"
                            height="48"
                            class="m-1"
                            v-if="
                              program.offers_double_bounty &&
                              program.active_campaign
                            "
                          >
                            <image
                              xlink:href="../../../assets/icons/double-bounty-icon.png"
                              width="48"
                              height="48"
                            />
                          </svg>
                          <div class="text-right">
                            <span class="pb-1" v-text="$ml.get('rewards')"
                              >Recompensas</span
                            >
                            <h6
                              v-if="program.currency === 'BRL'"
                              style="white-space: nowrap"
                            >
                              {{ $utils.convertMoney(minBounty) }} -
                              {{ $utils.convertMoney(maxBounty) }}
                            </h6>
                            <h6
                              v-else-if="program.currency === 'USDT'"
                              style="white-space: nowrap"
                            >
                              {{ $utils.convertMoney(minBounty) }} -
                              {{ $utils.convertMoney(maxBounty) }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-nav tabs>
              <b-nav-item
                :active="menuItem === 'detail'"
                @click="menuItem = 'detail'"
                >{{ this.$ml.get("details") }}</b-nav-item
              >
              <b-nav-item
                :active="menuItem === 'updates'"
                @click="menuItem = 'updates'"
              >
                <!-- :disabled="!!programUpdates.length" -->
                {{
                  this.$ml
                    .with("numberOfUpdates", programUpdates.length)
                    .get("updates")
                }}
              </b-nav-item>
            </b-nav>
            <div v-show="menuItem === 'detail'">
              <ProgramDetail :program="program" />
            </div>
            <div v-if="menuItem === 'updates'">
              <ProgramUpdates :programUpdates="programUpdates" />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import ProgramDetail from "../../../components/programDetail";
import ProgramUpdates from "../../../components/programUpdates.vue";
import ProgramService from "../../../services/program.service";
import CredentialService from "../../../services/credential.service";
import ScoreMultiplierIcon from "../../../components/ScoreMultiplierIcon";

export default {
  components: {
    ProgramDetail,
    ProgramUpdates,
    ScoreMultiplierIcon,
  },
  data() {
    return {
      programUpdates: [],
      menuItem: "detail",
      program: {
        optional_rewards: [],
      },
      id: "",
      textTolltip: "Copiar link",
      url: window.location.origin,
      file: "",
      online: false,
      activeSubscribe: false,
      haveCredentials: false,
      twoFactoryAuthentication: false,
      user2fa: false,
      hallOfFame: false,
      emailCodeRequired: false,
    };
  },
  mounted() {
    this.user2fa = this.$store.getters["getTwoFactorAuthLogin"];
    this.emailCodeRequired = this.$store.getters["getEmailCodeRequired"];
    
    this.id = this.$route.fullPath.split("?")[1];
    this.changeProgram(this.id);
  },
  destroyed() {
    this.$utils.updateTitlePage(
      "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
    );
  },
  computed: {
    minBounty() {
      let min_bounty = this.program?.min_bounty;
      if (this.program?.active_campaign && this.program?.offers_double_bounty) {
        min_bounty = min_bounty * 2;  
      }
      return min_bounty ?? 0;
    },
    maxBounty() {
      let max_bounty = this.program?.max_bounty;
      if (this.program?.active_campaign && this.program?.offers_double_bounty) {
        max_bounty = max_bounty * 2;
      }
      return max_bounty;
    },
  },
  methods: {
    ...mapActions(["setSubmitReport", "setpProgramWithout"]),


    async getCredential(idProgram) {
      try {
        const { data } = await CredentialService.getCredential(idProgram);
        this.haveCredentials = data;
      } catch (error) {
        console.log(error);
      }
    },

    getUpdateMessages() {
      ProgramService.getProgramUpdates(this.id)
        .then(({ data }) => (this.programUpdates = data))
        .catch(({ response }) => console.log(response));
    },

    activateSubscribe() {
      ProgramService.putSubscribe(this.id).then((response) => {
        const successfullyRequested = response.data === "Ok";
        if (successfullyRequested) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("emailNotification"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.changeProgram(this.id);
        }
      });
    },

    deleteSubscribe() {
      ProgramService.deleteSubscribe(this.id).then((response) => {
        const successfullyRequested = response.data === "Ok";
        if (successfullyRequested) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("emailNotificationDisabled"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.changeProgram(this.id);
        }
      });
    },

    changeProgram(id) {
      this.optional_rewards = [];
      ProgramService.getProgramDetail(id).then(
        (response) => {
          this.program = response.data;
          this.hallOfFame = response.data.settings?.hallOfFame;
          this.$utils.updateTitlePage(
            response.data.name ??
              "Bughunt - Plataforma De Segurança E Recompensa Por Bugs"
          );
          this.program.haveCredentials = this.haveCredentials;
          this.program._id = id;
          this.activeSubscribe = response?.data?.subscription;
          this.twoFactoryAuthentication =
            response?.data?.settings?.twoFactorAuthentication ?? false;
          // console.log(response?.data?.settings?.twoFactorAuthentication);
          this.getUpdateMessages();

          if (this.program.vpn_required) {
            this.changeProgramVpn(id);
          }

          if (this.haveCredentials) {
            this.getCredential(this.id);
          }

          if(this.$store.getters['getProgramWithout']){ 
             this.setpProgramWithout(''); 
             this.submitReport()
          }
        },
        () => {
          this.$router.push("/program");
        }
      );
    },

    async changeProgramVpn(id) {
      ProgramService.getProgramVpn(id).then((response) => {
        if (response.data.vpn_file) {
          this.online = response.data.online;
          this.file = "data:application/zip;base64," + response.data.vpn_file;
        }
      });
    },

    submitReport() {
      if (this.twoFactoryAuthentication && !this.user2fa && !this.emailCodeRequired)
        return this.validateFactoryAuthentication();
      this.program.id = this.$route.fullPath.split("?")[1];

      this.setSubmitReport({
        program: this.program,
      });

      this.$router.push({
        path: "/program/submit",
        name: "programSubmit",
        query: {},
        params: {
          id: this.id,
          program: this.program,
        },
      });
    },

    copyLink() {
      var hiddenField = document.getElementById("inputSlug");
      hiddenField.select();
      document.execCommand("copy");
      this.textTolltip = "Link copiado!";
    },

    toggleSubscribe() {
      this.activeSubscribe = !this.activeSubscribe;

      if (this.activeSubscribe) {
        this.activateSubscribe();
        return;
      }
      return this.deleteSubscribe();
    },

    validateFactoryAuthentication() {
      Swal.fire({
        title: this.$ml.get("attention"),
        html: this.$ml.get("alertTwoFactory"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra btn-swal",
          confirmButton: "btn-swal",
        },
        confirmButtonText: this.$ml.get("activate"),
        cancelButtonText: this.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          this.$router.push({
            name: "account",
            params: { authentication: "authentication" },
          });
          return;
        } else {
          this.loading = false;
        }
      });
    },

    openHof() {
      window.open(
        `${window.location.origin}/hall-of-fame/${this.program.slug}`,
        "_blank"
      );
    },
  },
};
</script>
<style>
.detailPaused {
  font-size: 14px;
  font-weight: 500;
}
.title-subscribe {
  font-family: "Poligon", sans-serif;
  color: rgb(125, 133, 142);
}
.validate-msg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  padding: 4px 10px;
  background: #e9ecef;
  border-radius: 6px;
  margin-bottom: 10px;
}
.validate-msg p {
  margin: 0px;
  padding: 0px;
}
div.container-two-factory {
  box-shadow: 0px 1px 1px #cccccc7e;
}
p.two-factory-descrition {
  text-align: center;
  font-size: 1rem;
}
p.two-factory-descrition span {
  font-weight: 500;
}
.btn-swal {
  width: 120px;
}
</style>
